<template>
  <div class="base_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('systemManagement') }} > {{ $t('Q&ASystemManage') }}</div>
    <div class="common-table-cnt common-aside-cnt-top">
      <div class="common-aside">
        <div class="serachBar">
          <el-input :placeholder="$t('tenantName')" v-model="ouName" clearable></el-input>
        </div>
        <el-tree
          :data="tenantList"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          highlight-current
          ref="tenantTree"
        >
        </el-tree>
      </div>
      <div class="common-aside-main " style="right:15px;">
        <div class="search search-container">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item :label="$t('Field')">
              <el-select
                v-model="domainId"
                filterable
                clearable
                :placeholder="$t('peaseSelect') + $t('Field')"
                :popper-append-to-body="false"
                @change="selectDomain"
                style="width:auto"
              >
                <el-option :value="item.id" v-for="item of domainList" :key="item.id" :label="item.name"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="showSaveDomain">
              <el-button type="primary" @click="saveDomain">{{ $t('updateFields') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="main table-box">
          <!-- table 列表 -->
          <el-table :data="ouBookList" style="width: 100%;" @sort-change="sortChange">
            <el-table-column
              type="index"
              :index="indexMethod"
              :label="$t('SerialNo')"
              align="center"
              width="80"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="ouName"
              :label="$t('mechanism')"
              sortable="custom_sou.name"
              :sort-orders="['ascending', 'descending']"
            ></el-table-column>
            <el-table-column :label="$t('book')">
              <template slot-scope="scope">
                <template v-for="bookName in scope.row.bookList">
                  {{ bookName }}
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('operationh')" width="150" align="center">
              <template slot-scope="scope">
                <span class="editClick" @click="openOuBookDialog(scope.row)">{{ $t('toConfigure') }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
             class="pagination"
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="currentPage"
             :page-sizes="[10, 20, 50, 100]"
             :page-size="pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="totalData"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!--配置组织书籍窗口-->
    <el-dialog
      :title="$t('configuringInstitutionalBooks')"
      :visible.sync="ouBookDialogVisible"
      :close-on-click-modal="false"
      @close="closeOuBookDialog"
      :append-to-body="true"
    >
      <!-- 书籍列表 -->
      <div class="common-blue-contain">
        <el-form :model="newUserForm">
          <el-form-item :label="$t('book')" label-width="130px" :required="true">
            <el-input
                    v-model="bookConfig"
                    :placeholder="$t('pleaseEnter') + $t('book')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOuBook()">{{ $t('determine') }}</el-button>
        <el-button @click="ouBookDialogVisible = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formInline: {},
      // 所有租户
      tenantList: [],
      // 租户配置书籍列表
      ouBookList: [],
      // 租户领域列表
      domainList: [],
      // 更新领域按钮
      showSaveDomain: false,
      // 租户领域id
      domainId: null,
      // 书籍列表
      bookList: [],
      // 配置书籍弹窗
      ouBookDialogVisible: false,
      // 勾选的书籍
      selectionBook: [],
      bookConfig: "",
      // 机构树租户数据格式
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      // 租户过滤
      ouName: '',
      formSear: {},
    }
  },
  watch: {
    // 机构树搜索名字监听
    ouName(val) {
      this.$refs.tenantTree.filter(val)
    },
  },
  methods: {
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formSear.sortColName = !order ? null : column.sortable
      this.formSear.useAsc = order === 'descending' ? 0 : 1
    },
    // 获取领域列表
    getTenantDomain() {
      this.domainId = null
      getDomainId({ tenantId: this.tenantId }).then(res => {
        if (res.state === 0) {
          this.domainId = res.data
        }
      })
    },
    // 获取领域列表
    getDomain() {
      domainList().then(res => {
        if (res.state === 0) {
          this.domainList = res.data
        }
      })
    },
    // 更新领域
    selectDomain() {
      this.showSaveDomain = true
    },
    // 更新领域
    saveDomain() {
      domainUpdate({ tenantId: this.tenantId, domainId: this.domainId }).then(res => {
        if (res.state === 0) {
          success(this.$t('updateFieldsucceeded'))
          this.showSaveDomain = false
        }
      })
    },
    // 所有租户根组织架构数据
    getTenantList() {
      orgunitRootList().then(res => {
        if (res.state === 0) {
          this.tenantList = res.data
          // 查询第一个机构对应部门书籍配置信息
          if (this.tenantList && this.tenantList.length > 0) {
            this.tenantId = this.tenantList[0].tenantId
            this.getTenantDomain()
            this.searchOuBookList()
            this.$nextTick(() => {
              this.$refs.tenantTree.setCurrentKey(this.tenantList[0].id)
            })
          }
        }
      })
    },
    // 当前机构/用户
    handleNodeClick(data) {
      this.showSaveDomain = false
      this.tenantId = data.tenantId
      this.getTenantDomain()
      this.searchOuBookList()
    },
    // 查询部门书籍配置信息
    searchOuBookList() {
      this.currentPage = 1
      this.getOuBookList()
    },
    // 部门书籍配置信息
    getOuBookList() {
      this.ouBookList = []
      ouBookPage({
        tenantId: this.tenantId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sortColName: this.formSear.sortColName,
        useAsc: this.formSear.useAsc,
      }).then(res => {
        if (res.state === 0) {
          this.ouBookList = res.data.list
          this.totalData = res.data.total
        } else {
          this.totalData = 0
        }
      })
    },
    // 打开配置书籍弹窗
    openOuBookDialog(data) {
      // NOSONAR
      this.ouId = data.id
      if (data.bookList) {
        this.bookConfig = data.bookList.join('');
      } else {
        this.bookConfig = ''
      }
      this.ouBookDialogVisible = true
    },
    // 关闭配置书籍弹窗
    closeOuBookDialog() {
      this.ouBookDialogVisible = false
      this.ouId = null
      this.bookConfig = ''
    },
    // 保存勾选书籍
    saveOuBook() {
      bookUpdate({ tenantId: this.tenantId, ouId: this.ouId, books: [this.bookConfig] }).then(res => {
        if (res.state === 0) {
          success(this.$t('bookSavedSuccessfully'))
          this.getOuBookList()
          this.closeOuBookDialog()
        }
      })
      this.ouBookDialogVisible = true
    },
    // 每页查询 val 条数据
    handleSizeChange(val) {
      this.pageSize = val
      this.getOuBookList()
    },
    // 点击页数跳转到 val 页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getOuBookList()
    },
    indexMethod(index) {
      return index + 1
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
  },
  created() {},
  mounted() {
    this.getDomain()
    this.getTenantList()
  },
}
import { orgunitRootList } from '@/api/upgrade'
import { getDomainId, domainList, domainUpdate, bookList, bookUpdate, ouBookPage } from '@/api/qaManage'
import { success } from '@/util/common'
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 640px
  min-height 460px;/* no */
  overflow: auto
>>>.el-tree-node__content:hover .editBtn
  display inline-block
.base_main
  .el-tree
    height: 92%
    overflow-y auto
  .common-aside-main
    margin-left 10px
  .serachBar
    padding 10px
    font-weight: bold
    font-size 16px
    color #fff
  .serachBtn
    margin-left 40%
  .serachBar:before
    display inline-block
    content ''
    width 3px
    height 15px
    margin-right 10px
    border-radius 3px
    background-color #00DDFE
    .el-input
      width 100%
  .title
    font-size 16px
    margin-bottom 28px
  .main
    .user_input
      margin-top 10px
      width 100px
      margin-left 10px
    .el-button
      margin-left 10px
    .pagination
      float right
      margin-top 1%
.custom-tree-node
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 0.10416667rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
.node-txt
  font-size 16px;/*no*/
.el-form-item__content
  span
    position absolute
    left 0
    top 32px
    font-size 14px
    color #ed3f14

>>>.el-popper
  min-width 100%!important
.search
  .el-form
    .el-form-item:first-child
      float: left
      display: flex
</style>
